var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FEE5F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 20.0226C29 15.0421 24.968 11 20 11C15.032 11 11 15.0421 11 20.0226C11 24.3895 14.096 28.0256 18.2 28.8647V22.7293H16.4V20.0226H18.2V17.7669C18.2 16.0256 19.613 14.609 21.35 14.609H23.6V17.3158H21.8C21.305 17.3158 20.9 17.7218 20.9 18.218V20.0226H23.6V22.7293H20.9V29C25.445 28.5489 29 24.7053 29 20.0226Z",
    fill: "#FF3093"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.19524dcdcb63204bb76052d76cc7cfd0.svg";
export { ForwardRef as ReactComponent };